module.exports = __webpack_public_path__ + "img/coin.88e1361f.png";